module.exports = __webpack_public_path__ + "img/garden-location.0d4c2efc.jpg";